import React from 'react';
import { PrivacyPolicy } from 'cpfr-common';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import { HeroImage } from '@cp-shared-19/frontend-ui';

export const PrivacyPolicyUi: React.FC<{ privacyPolicy?: PrivacyPolicy }> = ({ privacyPolicy }) => {
    if (!privacyPolicy) {
        return null;
    }

    const { teaser, content } = privacyPolicy;

    const teaserComponent = teaser ? (
        <HeroImage title={teaser.title} imageUrl={teaser.imageUrl} shallow={true} inverted={true} />
    ) : null;

    const contentComponent = content ? <div dangerouslySetInnerHTML={{ __html: content }} /> : null;

    return (
        <>
            {teaserComponent}
            <ContentSection pageWrapSize="medium" className={'u-mt'}>
                {contentComponent}
            </ContentSection>
        </>
    );
};
